import { React, useState } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import AppButton from "../../base/AppButton.component";
import VerificationLayout from "../../layout/VerificationLayout.component";
import NoInsurance from "../../../assets/gifs/no-insurance.json";
import { TYPE, lottieLoopOptions, roundOf } from "../../../utils/Utils";
import { borderRadius, Box } from "@mui/system";
import { useVerification } from "../../../context/Verification.context";
import SaveMoneyImage from "../../../assets/images/insurance.png";
import { useQuery } from "@apollo/client";
import Lottie from "react-lottie";
import { useAppContext } from "../../../context/App.context";
import QuoteQuestionsComponent from "./QuoteQuestions.component";
import HocPopup from "../../../hoc/hocPopup";
import { FETCH_QUESTIONNAIRE } from "../../../graphql/query/query";
import TradeAndQuoteComponent from "../../../utils/TradeAndQuote.component";
import ToggleComponent from "../heygenAI/Toggle.component";
import { ArtifactStyle } from "./document/artifactResponse/VerficationArtifactsStyles";
import FetchAIVideoUrl from "../heygenAI/FetchAIVideoUrl";
import TextUnAvailable from "./document/artifactResponse/TextUnAvailable";
import { navigateAfterQuote } from "../../../utils/videoPlayer";

const DIALOG_INITIAL_STATE = {
  open: false,
  bodyType: TYPE.DEFAULT,
  title: "",
  body: null,
};

const RequestQuoteComponent = ({ dialog }) => {
  const navigate = useNavigate();
  const verification = useVerification();

  const [openWalkthrough, setOpenWalkthrough] = useState(false);

  const [animateIn, setAnimateIn] = useState(false);
  const [duration, setDuration] = useState(0);
  const [direction, setDirection] = useState(null);
  const [showSurveyButton, setShowSurveyButton] = useState(false);

  lottieLoopOptions.animationData = NoInsurance;

  let getPercentage = verification?.percentage;
  let getPremium = verification?.customer?.totalPremiumCents;

  let percentageCalculation = ((getPercentage / 100) * getPremium) / 12;
  percentageCalculation = Math.round(percentageCalculation);

  const padding = {
    xs: 2,
    sm: 4,
    md: 4,
    lg: 6,
    xl: 6,
  };

  const { data: fetchQuestionnaire, loading } = useQuery(FETCH_QUESTIONNAIRE, {
    variables: {
      questionnaireInput: {
        dealership_id: parseInt(verification.dealershipId),
      },
    },
  });
  const artifact = verification.tradeQuote?.find(
    (data) => data.__typename === "QuoteArtifact"
  );
  console.log("trade", artifact);
  const videoUrl = {
    english_url: artifact?.quote_ai_url?.english_url,
    spanish_url: artifact?.quote_ai_url?.spanish_url,
  };
  const QuestionVideoUrl = {
    english_url: artifact?.QuoteArtifact?.english_url,
    spanish_url: artifact?.QuoteArtifact?.spanish_url,
  };
  const enOptions = JSON.parse(artifact?.quote_options || "[]");
  const esOptions = JSON.parse(artifact?.es_quote_options || "[]");
  const displayOptions = verification.aiData.spanish ? esOptions : enOptions;

  const hasMessage = verification.aiData.spanish
    ? !!artifact?.es_text
    : !!artifact?.text;

  return (
    <>
      {/* {openWalkthrough && (
        <QuoteQuestionsComponent
          videoUrl={videoUrl}
          open={openWalkthrough}
          handleClose={() => setOpenWalkthrough(false)}
          walkthrough={true}
        />
      )} */}
      <VerificationLayout>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            // justifyContent: "space-between",
            // gap: "2%",
            // py: "3%",
          }}
        >
          {!verification?.aiData?.isAI || !verification?.aiData?.spokeperson ? (
            // ||
            // !artifact?.quote_ai_url?.english_url
            <Box
              sx={{
                display: "flex",
                p: "3%",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                alignItems: "center",
                // gap: "2%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: "10%",
                }}
              >
                <ToggleComponent isClose={false} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "60%",
                  gap: 2,
                  // pt: 3,
                }}
              >
                <TextUnAvailable
                  text={artifact?.text}
                  es_text={artifact?.es_text}
                />
                {verification.customer.premium &&
                  parseInt(getPercentage) > 1 &&
                  hasMessage && (
                    <AppButton
                      buttonText={
                        !verification?.aiData?.spanish
                          ? `Possible Savings: $${percentageCalculation}/month`
                          : `Posibles ahorros: $${percentageCalculation}/mes`
                      }
                      size="large"
                      variant="outlined"
                      sx={{
                        color: "primary",
                        borderColor: "Theme.palette.primary.main",
                      }}
                      disabled={loading}
                    />
                  )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "center",
                  height: "30%",
                }}
              >
                <>
                  <AppButton
                    buttonText={displayOptions?.[0] || "Yes save me money"}
                    size="large"
                    variant="contained"
                    sx={{ width: window.innerWidth <= 750 ? "90%" : "50%" }}
                    clickHandler={() => {
                      dialog({
                        open: true,
                        bodyType: TYPE.QUOTE_QUESTIONS,
                        body: (
                          <QuoteQuestionsComponent
                            fetchQuestionnaire={fetchQuestionnaire}
                            queryLoading={loading}
                            artifact={artifact}
                            videoUrl={QuestionVideoUrl}
                            // open={openWalkthrough}
                            // handleClose={() => setOpenWalkthrough(false)}
                            // walkthrough={true}
                          />
                        ),
                        maxWidth: "sm",
                        fullScreen: true,
                      });
                    }}
                    disabled={loading}
                  />

                  <AppButton
                    buttonText={displayOptions?.[1] || "Maybe later"}
                    size="large"
                    variant="outlined"
                    sx={{
                      width: window.innerWidth <= 750 ? "90%" : "50%",

                      color: "#808080",
                      borderColor: "#808080",
                    }}
                    clickHandler={() => {
                      navigateAfterQuote(navigate, verification);
                    }}
                    disabled={loading}
                  />
                  <span style={{ fontSize: "10px", color: "gray" }}>
                    *By Clicking “YES”, you are acknowledging that your
                    information will be sent to one or more affiliates for
                    quotes or other services
                  </span>
                </>
              </Box>
            </Box>
          ) : (
            <>
              {((videoUrl.english_url && !verification?.aiData?.spanish) ||
                (videoUrl.spanish_url && verification?.aiData?.spanish)) && (
                <FetchAIVideoUrl
                  videoUrl={videoUrl}
                  currentIndex={0}
                  pagination={false}
                  isAI={true}
                  animateIn={animateIn}
                  setAnimateIn={setAnimateIn}
                  duration={duration}
                  setDuration={setDuration}
                  direction={direction}
                  isClose={false}
                  showSurveyButton={showSurveyButton}
                  setShowSurveyButton={setShowSurveyButton}
                  trade={true}
                  artifact={artifact}
                />
              )}
            </>
          )}
        </Box>
      </VerificationLayout>
    </>
  );
};
export default HocPopup(RequestQuoteComponent);
{
  /* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,premium
          justifyContent: "center",
          alignItems: "center",
          padding: { padding },
        }}
      >
        {verification.customer.premium ? (
          <img
            src={SaveMoneyImage}
            alt=""
            width={
              window.innerHeight >= 1440
                ? 360
                : window.innerHeight >= 1050
                ? 360
                : window.innerHeight >= 900
                ? 300
                : 150
            }
          />
        ) : (
          <Lottie
            options={lottieLoopOptions}
            height={
              window.innerHeight >= 1440
                ? 360
                : window.innerHeight >= 1050
                ? 360
                : window.innerHeight >= 900
                ? 300
                : 200
            }
            width={
              window.innerHeight >= 1440
                ? 360
                : window.innerHeight >= 1050
                ? 360
                : window.innerHeight >= 900
                ? 300
                : 200
            }
          />
        )}
      </Box> */
}

{
  /* <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {verification.customer. ? (
          <Box m={window.innerWidth <= 750 ? 2 : null}>
            <Typography
              variant="h6"
              align="left"
              style={{ marginTop: window.innerWidth <= 750 ? "0px" : "2px" }}
            >
              We noticed you're paying{" "}
              {window.innerWidth <= 750 ? <br /> : null}
              <span style={{ color: "green", fontWeight: "bold" }}>
                $ {roundOf(getPremium)}
              </span>{" "}
              a year for insurance. That looks like way too much !
            </Typography>
            <br />
            <Typography
              variant="h6"
              align="left"
              style={{ marginTop: window.innerWidth <= 750 ? "0px" : "2px" }}
            >
              Customers like you can save as much as{" "}
              {window.innerWidth <= 750 ? <br /> : null}
              <span style={{ color: "green", fontWeight: "bold" }}>
                $ {roundOf(percentageCalculation)}
              </span>{" "}
              a year when they switch insurance carriers
            </Typography>
            <br />
            <Typography
              variant="h6"
              align="left"
              style={{ marginTop: window.innerWidth <= 750 ? "0px" : "2px" }}
            >
              Would you like to see how much{" "}
              <span style={{ color: "green", fontWeight: "bold" }}>YOU</span>{" "}
              can save ?
            </Typography>
          </Box>
        ) : (
          <Typography
            variant="h6"
            align="left"
            style={{ marginTop: window.innerWidth <= 750 ? "0px" : "2px" }}
          >
            Would you like us to give an easy, free, no obligations quote?
          </Typography>
        )}
      </Box> */
}
